// extracted by mini-css-extract-plugin
module.exports = {"label":"styles-module--label--1UhRS","value":"styles-module--value--3rgS-"};